import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { RegisterLeaveComponent } from './component/register-leave.component';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TransportInfoPanelModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  declarations: [RegisterLeaveComponent],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ]
})
export class RegisterLeaveModule { }
